import Enum from 'enum'

export const releaseTrack = new Enum({
  'Production': 'production',
  'Beta': 'beta-track',
  'Alpha': 'alpha-track'
})